import React from "react";

const ChevronDownIcon = props => (
  <svg
    width="18px"
    height="8px"
    viewBox="0 0 20 10"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    style={props.style}
    className={props.className}
  >
    <desc>Chevron down icon</desc>
    <defs />
    <g id="Page-1" stroke="none" strokeWidth="2" fill="none" fillRule="evenodd">
      <g id="Group" transform="translate(1.000000, 0.000000)" stroke="#363636">
        <polyline id="Line" points="0 0 8 8 16 0" />
      </g>
    </g>
  </svg>
);

export default ChevronDownIcon;



// WEBPACK FOOTER //
// ./src/components/Icons/ChevronDownIcon.js